import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import PageHeader from "components/ui/page-header";
import { requestImportTracking } from "actions/import-tracking";
import SelectInput from "components/forms/select-input";
import { InlineWaiting } from "components/ui";
import ImportResults from "../admin-tools/import-results";

class FulfillmentTrackingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headersCheckboxChecked: true,
      fulfillmentType: "",
      company_id: "",
      errors: {}
    };
  }

  onFulfillmentTrackingSubmit = e => {
    e.preventDefault();
    try {
      if (!this.state.fulfillmentType) {
        this.setState({ errors: { fulfillmentType: "Required." } });
        return;
      }
      let formData = new FormData();
      formData.append("company", this.state.fulfillmentType);
      formData.append("company_id", this.state.company_id);
      formData.append("file", this.filesInput.files[0]);
      formData.append("headers", this.state.headersCheckboxChecked);
      this.props.requestImportTracking(formData);
      this.setState({
        headersCheckboxChecked: true,
        fulfillmentType: "",
        filesInput: null,
        errors: {}
      });
      this.filesInput.value = null;
    } catch (e) {
      /* handle error */
    }
  };

  handleChange = ({ target }) => {
    const name = target.name;
    let value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ [name]: value });
  };

  render() {
    const { accountNumberFailures, companyOptions } = this.props;
    return (
      <div>
        <PageHeader title="Import tracking" />
        <div className="column">
          <div className="row">
            <form
              encType="multipart/form-data"
              onSubmit={this.onFulfillmentTrackingSubmit}
            >
              <input
                ref={input => {
                  this.filesInput = input;
                }}
                name="file"
                required
                type="file"
              />
              <div style={{ width: 500 }}>
                <div>
                  <SelectInput
                    name="company_id"
                    label="Company"
                    value={this.state.company_id}
                    error={this.state.errors}
                    options={companyOptions}
                    onChange={this.handleChange}
                  />
                </div>
                <SelectInput
                  name="fulfillmentType"
                  label="Fulfillment Type"
                  value={this.state.fulfillmentType}
                  error={this.state.errors}
                  options={[
                    { text: "McKesson", value: "McKesson" },
                    { text: "VGM", value: "VGM" },
                    { text: "VGM - App Tracking", value: "VGM_APP_TRACKING" },
                    { text: "Internal", value: "Internal" },
                    { text: "Independence", value: "Independence" },
                    { text: "CPAP_Dropship", value: "CPAP_Dropship" },
                    { text: "PPM", value: "PPM" },
                    { text: "Bonafide", value: "BONAFIDE" }
                  ]}
                  onChange={this.handleChange}
                />
              </div>
              <label>
                Headers
                <input
                  style={{ marginLeft: 10 }}
                  name="headersCheckboxChecked"
                  type="checkbox"
                  checked={this.state.headersCheckboxChecked}
                  onChange={this.handleChange.bind(this)}
                />
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <input
                  style={{
                    marginBottom: 0,
                    marginRight: 10
                  }}
                  className="button"
                  type="submit"
                  value="Submit"
                  disabled={this.props.isFetching}
                />
                {this.props.isFetching && (
                  <InlineWaiting
                    reason={`submitting ${this.state.fulfillmentType} tracking`}
                  />
                )}
              </div>
            </form>

            {this.props.success && (
              <div className="alert-box success">
                Your form has been submitted successfully!
              </div>
            )}
            {!this.props.success && (
              <ImportResults
                results={accountNumberFailures}
                title={`The following ${accountNumberFailures.length} tracking updates failed`}
                fields={[{ title: "Account Number", name: "acctNum" }]}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    success: state.getIn(["fulfillment", "importTrackingSuccess"]),
    companyOptions: selectors.getFormOptionsCompany(state),
    isFetching: state.getIn(["tracking-import"]).isFetching,
    accountNumberFailures: state.getIn(["tracking-import"])
      .accountNumberFailures
  }),
  {
    requestImportTracking
  }
)(FulfillmentTrackingForm);

FulfillmentTrackingForm.propTypes = {
  success: PropTypes.bool,
  requestImportTracking: PropTypes.func,
  isFetching: PropTypes.bool,
  accountNumberFailures: PropTypes.array,
  companyOptions: PropTypes.array
};
